<template>
  <div class="bg-purple-600 bg-opacity-25  flex  flex-col justify-center items-center min-h-screen">
    <div class="text-purple-600 text-4xl mb-20">
      巨泛科技后台管理系统
    </div>

    <div class="border-solid border-2 border-light-blue-500 w-1/4 mx-auto mb-60
      h-1/4   rounded-lg  bg-white shadow-2xl shadow-light-100 line-through">

      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
        class="demo-ruleForm   mt-20">
        <el-form-item label="账号" prop="username">
          <el-input type="text" v-model="ruleForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button class=" w-4/5 mx-auto" type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import { login } from "../api/api";
export default {
  data() {
    return {
      ruleForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入账号！", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码！", trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          login(this.ruleForm).then(({data}) => {
            if(data.code == 200 ){
              localStorage.setItem('token', data.token);
              localStorage.setItem('userInfo', this.ruleForm.username);
              this.$message({
                message: data.msg,
                type: "success"
              })
              this.$router.push('/')

            }
            this.$message({
                message: data.msg,
                type: "error"
              })

          })

        }
      });
    }
  }
};
</script>

<style scoped>
.el-color-picker__icon,
.el-input,
.el-textarea {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/login/index.vue